module.exports = __webpack_public_path__ + "img/05.a14d151f.png";